var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBusinessVehicle64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./BusinessVehicle64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pictogram",
    transform: "translate(5.000000, 14.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Window",
    fill: "#FFFFFF",
    points: "33.0313272 9 46.5111883 9 54 21.0110312 54 29.989277 30 30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Body",
    fill: "#FFCC00",
    x: 33,
    y: 21,
    width: 21,
    height: 9
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rear",
    fill: "#FFFFFF",
    points: "13.0078173 30 33.0139635 29.9999991 33.0139635 3.55271368e-15 0.0139634787 3.55271368e-15 0.0139634787 7.99006139 0.0139634787 30 12.0191787 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,36 C40.24,36 38,33.76 38,31 C38,28.2366667 40.24,26 43,26 C45.7633333,26 48,28.2366667 48,31 C48,33.76 45.7633333,36 43,36 Z",
    id: "FrontWheel",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,31 C17,33.76 14.7633333,36 12,36 C9.24,36 7,33.76 7,31 C7,28.2366667 9.24,26 12,26 C14.7633333,26 17,28.2366667 17,31 L17,31 Z",
    id: "BackWheel",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,21 L53,21",
    id: "Line",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBusinessVehicle64);
export default __webpack_public_path__ + "static/media/pictogramBusinessVehicle64.92d6462b026fb5c369ff66ab1b32490b.svg";
export { ForwardRef as ReactComponent };